import React, { ReactNode } from "react";
import { Field, useField } from "formik";
import cssModuleClassNames from "classnames/bind";
import cssStyles from "./radio-card.module.css";
const classNames = cssModuleClassNames.bind(cssStyles);

const RadioCard: React.FC<any> = ({ styles, name, label, desc, value }) => {
  const idName = `hc-${name}-${value}`;
  const [field] = useField(name);
  return (
    <div className={classNames(styles.radioCard, { small: !desc })}>
      <Field
        type="radio"
        id={idName}
        value={value}
        name={name}
        checked={field.value === value}
      />
      <label htmlFor={idName}>
        <div className={styles.title}>{label}</div>
        {desc && <div className={styles.desc}>{desc}</div>}
      </label>
    </div>
  );
};

interface Option {
  label: ReactNode;
  value: string;
  desc?: ReactNode;
}

interface RadioGroupProps {
  name: string;
  options: Option[];
}

/**
 * @deprecated in favor of RadioSelectComponent
 * Radio control with a card shape
 *
 * Example:
 * ```
 *   <RadioCardGroup
 *     name="size"
 *     options={[
 *       { label: "Small", value: "S", desc: "This describes.."},
 *       { label: "Medium", value: "M" },
 *       { label: "Large", value: "L" },
 *     ]}
 *  />
 * ```
 */
export const RadioCardGroup: React.FC<RadioGroupProps> = props => (
  <>
    {props.options.map(({ label, value, desc }, key) => (
      <RadioCard
        key={key}
        styles={cssStyles}
        label={label}
        value={value}
        desc={desc}
        name={props.name}
      />
    ))}
  </>
);
